import React from "react";
import { Backdrop } from "@mui/material";
import "./Loader.css";

const Loader = ({ open = true }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        backgroundColor: "rgba(255,255,255,0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
        padding: 2,
      }}
    >
      <div
        className="css-construction-logo"
        aria-hidden="true"
        style={{
          transform: "scale(0.6)", // ✅ Shrink to 60% of original size
          transformOrigin: "center",
        }}
      >
        <div className="hardhat">
          <div className="hat-top" />
          <div className="hat-brim" />
          <div className="hat-ridge" />
        </div>

        <div className="crane">
          <div className="crane-arm" />
          <div className="crane-cable" />
          <div className="crane-hook" />
          <div className="crate" />
        </div>
      </div>

      <div
        className="loader-text"
        style={{
          fontSize: "0.95rem", // ✅ Standard readable text
          color: "#0E4C84",
          marginTop: "12px",
          fontWeight: 500,
        }}
      >
        Surveying site... Please wait
      </div>
    </Backdrop>
  );
};

export default Loader; 